import { STORE_CUSTOMIZATION } from './constants';
import { getStoreType } from './getStoreType';

export function isAddressMandatoryForService() {
  return getStoreType() === STORE_CUSTOMIZATION.SERVICE_BASED_WITH_ADDRESS_ENABLED;
}
